import {useCallback, useEffect, useState} from 'react'
import className from '../../common/className.js'
import {
  getActiveRequests,
  subscribeToRequests,
  unsubscribeFromRequests,
} from '../../common/ordoroFetch.js'

const START_CLASS = 'start--indeterminate'
const END_CLASS = 'end--indeterminate'

function onRequest(requests, setIsRequesting) {
  setIsRequesting(filterRequests(requests).length > 0)
}

function filterRequests(requests) {
  return requests.filter(
    ({url, method}) =>
      !(url.match(/^http.*\/company\//) && method === 'get') &&
      url !== '/info.json' &&
      !url.match(/^http.*\/v3\/order\/counts.*created_after/) &&
      !url.match(/^http.*\/order\/.*created_after/) &&
      !url.match(/^http.*\/(product|address)\/\?.*&search/),
  )
}

function onAnimationEnd(phase, setPhase) {
  if (phase === END_CLASS) {
    setPhase('')
  }
}

export default function ProgressIndicator() {
  const [phase, setPhase] = useState('')
  const [isRequesting, setIsRequesting] = useState(false)

  const onRequestLocal = useCallback(
    (requests) => onRequest(requests, setIsRequesting),
    [],
  )

  useEffect(() => {
    subscribeToRequests(onRequestLocal)

    const requests = filterRequests(getActiveRequests())
    setIsRequesting(requests.length > 0)

    return () => {
      unsubscribeFromRequests(onRequestLocal)

      setIsRequesting(false)
    }
  }, [])

  useEffect(() => {
    setPhase(isRequesting ? START_CLASS : END_CLASS)
  }, [isRequesting])

  return (
    <div
      className={className`progress-indicator__outer ${phase}`}
      onAnimationEnd={() => onAnimationEnd(phase, setPhase)}
    >
      <div className="progress-indicator__inner" />
    </div>
  )
}
